import "@/assets/style/index.less";
import UtilStorage from "@/util/Common/UtilStorage";
import { App } from "@capacitor/app";
import { TextZoom } from "@capacitor/text-zoom";
import { autoAnimatePlugin } from "@formkit/auto-animate/vue";
// import "@fortawesome/fontawesome-free/css/all.css";
// import "@fortawesome/fontawesome-free/js/all.js";
import { isAndroidWebView, isIosWebview } from "@/script/detect-webview";
import { Capacitor } from "@capacitor/core";
import VueMask from "@devindex/vue-mask";
import * as Sentry from "@sentry/vue";
import "swiper/css";
import "swiper/css/pagination";
import { UAParser } from "ua-parser-js";
import { createApp } from "vue";
import "vue3-toastify/dist/index.css";
import MainApp from "./App.vue";
import "./assets/style/tailwind.css";
import router from "./router";
import store from "./store";

// document.addEventListener("deviceready", () => {
//   setTimeout(() => {
//     SplashScreen.hide();
//   }, 100);
// });

if (Capacitor.getPlatform() !== "web") {
  const style = document.createElement("style");
  style.textContent = `
    @font-face {
      font-family: 'Montserrat';
      src: local('Montserrat'), url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
    }
    
    @font-face {
      font-family: 'Roboto';
      src: local('Roboto'), url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
    }
  `;
  document.head.appendChild(style);
}

window.addEventListener("securitypolicyviolation", (e) => {
  if (
    e.blockedURI &&
    e.blockedURI.includes(" ") &&
    (e.violatedDirective === "img-src" || e.violatedDirective === "font-src")
  ) {
    const correctedUrl = e.blockedURI.replace(/\s+/g, "");
  }
});

window.addEventListener("securitypolicyviolation", (e) => {
  if (e.blockedURI && e.blockedURI.includes(" ")) {
    const correctedUrl = e.blockedURI.replace(/\s+/g, "");
  }
});

const app = createApp(MainApp)
  .use(store)
  .use(autoAnimatePlugin)
  .use(VueMask)
  .use(router);

const isPWAMode =
  window.matchMedia("(display-mode: standalone)").matches ||
  (window.navigator as any).standalone ||
  document.referrer.includes("android-app://");

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

const platform = Capacitor.getPlatform();

App.addListener("appUrlOpen", async (data) => {
  try {
    if (data.url.startsWith("forcemoneypro://")) {
      let access_token = null;
      const url = new URL(data.url);

      if (url.searchParams.has("access_token")) {
        access_token = url.searchParams.get("access_token");
      }

      if (!access_token && url.hash) {
        try {
          const hash = url.hash.replace("#", "?");
          const hashParams = new URLSearchParams(hash);

          if (hashParams.has("access_token")) {
            access_token = hashParams.get("access_token");
          } else {
            const hashParts = url.hash.split("&");
            for (const part of hashParts) {
              if (part.includes("access_token=")) {
                access_token = part.split("access_token=")[1];
                break;
              }
            }
          }
        } catch (e) {
          console.error(e);
        }
      }

      if (!access_token && url.pathname.includes("access_token=")) {
        const pathParts = url.pathname.split("access_token=");
        access_token = pathParts[1].split("&")[0];
      }

      if (!access_token && data.url.includes("access_token=")) {
        const urlParts = data.url.split("access_token=");
        access_token = urlParts[1].split("&")[0].split("#")[0];
      }

      if (access_token) {
        await UtilStorage.setItem("yandex_temp_token", access_token);

        router.push({
          path: "/login-yandex",
          query: {
            access_token: access_token,
            source: "appUrlOpen",
          },
        });
      } else {
        router.push({
          path: "/",
          query: { error: "token_not_found" },
        });
      }
    }
  } catch (error) {
    router.push({
      path: "/",
      query: { error: "url_processing_error" },
    });
  }
});

const isWebview = isSafari
  ? isIosWebview(window)
  : isAndroidWebView(navigator.userAgent);

const detectAppType = async () => {
  if (isPWAMode) return "PWA-версия";
  if (platform == "ios" || platform == "android") {
    const appInfo = await App.getInfo().then();
    const appVersion = `v${appInfo.version} ${appInfo.build}. ${platform}`;
    return appVersion;
  }
  return "Веб-версия";
};

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    app,
    dsn: "https://470a1a4825eb4d16b8fd9d92690212fd@glitforce.force2.ru/2",
    integrations: [],

    tracesSampleRate: 1,

    tracePropagationTargets: [
      "localhost",
      "https://pro.force2.ru",
      "https://devpro.force2.ru",
      "https://*.force2.ru",
      /^\//,
    ],

    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

const parser = new UAParser(navigator.userAgent);

if (platform != "web") {
  Sentry.configureScope(
    (scope: { setTag: (arg0: string, arg1: string) => void }) => {
      detectAppType().then((response) => {
        scope.setTag("version", response);
      });
    },
  );
  TextZoom.get().then((res) => {
    if (res.value > 1) {
      TextZoom.set({ value: 1 });
    }
  });
}

app.config.globalProperties.$PLATFORM = platform;
app.config.globalProperties.$IS_PWA = isPWAMode;
app.config.globalProperties.$IS_SAFARI = isSafari;
app.config.globalProperties.$BROWSER_NAME = parser.getBrowser().name;
app.config.globalProperties.$IS_WEBVIEW = isSafari
  ? isIosWebview(window)
  : isAndroidWebView(navigator.userAgent);

detectAppType().then((response) => {
  app.config.globalProperties.$APP_TYPE = response;
});

if ("serviceWorker" in navigator && platform == "web") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("sw.js")
      .then(() => {
        console.log("Service worker registered success");
      })
      .catch((error) => {
        console.log("Service worker registration failed:", error);
      });
  });
}

app.mount("#app");

// if (Capacitor.getPlatform() !== "web") {
//   setTimeout(() => {
//     SplashScreen.hide();
//   }, 500);
// }
